/**
 * @author Ehsan Elahi
 */
import { toast } from 'react-toastify';
var axios = require('axios');

export const stockRequestDataAsync = data => {
    return { type: 'FETCH_STOCK_REQUEST_COMPANY_DATA', data }
}

export const stockRequestItemDataAsync = data => {
    return { type: 'FETCH_STOCK_REQUEST_COMPANY_ITEM_DATA', data }
}

export const getStockRequestData = (token) => {
    return dispatch => {
        axios.defaults.headers.common['authorization'] = token;
        axios.get('/move_stock_company/getStockRequestData')
            .then(result => {
                dispatch(stockRequestDataAsync(result.data.reverse()))
            }).catch(err => {
                toast.error(`${err}`)
            })
    }
}

export const addMoveStockRequest = (token, data) => {
    return dispatch => {
        axios.defaults.headers.common['authorization'] = token;
        axios.post('/move_stock_company/addMoveStockRequest', { data })
            .then(result => {
                window.$('#addStockRequest').modal('hide');
                toast.success('Stock Request Added!')
                dispatch(getStockRequestData(token))
                dispatch(getStockRequestItemData(token))
            }).catch(err => {
                toast.error(`${err}`)
            })
    }
}

export const getStockRequestItemData = (token) => {
    return dispatch => {
        axios.defaults.headers.common['authorization'] = token;
        axios.get('/move_stock_company/getStockRequestItemData')
            .then(result => {
                dispatch(stockRequestItemDataAsync(result.data))
            }).catch(err => {
                toast.error(`${err}`)
            })
    }
}

export const updateMoveStockRequest = (token, data) => {
    return dispatch => {
        axios.defaults.headers.common['authorization'] = token;
        axios.post('/move_stock_company/updateMoveStockRequest', { data })
            .then(result => {
                toast.success('Stock Request Updated!')
                dispatch(getStockRequestData(token))
            }).catch(err => {
                toast.error(`${err}`)
            })
    }
}

export const deleteMoveStockRequest = (token, data) => {
    return dispatch => {
        axios.defaults.headers.common['authorization'] = token;
        axios.post('/move_stock_company/deleteMoveStockRequest', { data })
            .then(result => {
                toast.success('Stock Request Deleted!')
                dispatch(getStockRequestData(token))
            }).catch(err => {
                toast.error(`${err}`)
            })
    }
}

export const updateMoveStockRequestItem = (token, data) => {
    return dispatch => {
        axios.defaults.headers.common['authorization'] = token;
        axios.post('/move_stock_company/updateMoveStockRequestItem', { data })
            .then(result => {
                toast.success('Stock Item Updated!')
                dispatch(getStockRequestItemData(token))
            }).catch(err => {
                toast.error(`${err}`)
            })
    }
}

export const deleteMoveStockRequestItem = (token, data) => {
    return dispatch => {
        axios.defaults.headers.common['authorization'] = token;
        axios.post('/move_stock_company/deleteMoveStockRequestItem', { data })
            .then(result => {
                toast.success('Stock Item Deleted!')
                dispatch(getStockRequestItemData(token))
            }).catch(err => {
                toast.error(`${err}`)
            })
    }
}

export const approveStockRequest = (token, approvedData) => {
    return dispatch => {
        axios.defaults.headers.common['authorization'] = token;
        axios.post('/move_stock_company/approveStockRequest', { approvedData })
            .then(result => {
                toast.success('Stock Request Approved!')
                dispatch(getStockRequestData(token))
            }).catch(err => {
                toast.error(`${err}`)
            })
    }
}